<template>
  <ScriptYouTubePlayer
    :video-id="id"
    :width="160"
    :height="90"
    :root-attrs="{
      style: {
        width: 'auto',
      },
    }"
    trigger="immediate"
    @state-change="onStateChange"
  />
</template>

<script lang="ts" setup>
/// <reference types="youtube" />
defineProps<{
  id: string
}>()

// The YouTube player instance.
let player: YT.Player | null = null

const { setState } = useVideoTracking('youtube', {
  getCurrentTime: () => player?.getCurrentTime(),
  getDuration: () => player?.getDuration(),
  getVideoUrl: () => player?.getVideoUrl(),
  // This property exists, but is undocumented.
  // @ts-ignore
  getTitle: () => player?.videoTitle,
})

/**
 * Callback when the player state changes.
 */
function onStateChange(event: YT.OnStateChangeEvent) {
  player = event.target

  switch (event.data) {
    case YT.PlayerState.PAUSED:
    case YT.PlayerState.BUFFERING:
      setState('paused')
      break
    case YT.PlayerState.ENDED:
      setState('ended')
      break
    case YT.PlayerState.PLAYING:
      setState('playing')
      break
  }
}
</script>
